import { defineMessages } from 'react-intl';

export default defineMessages({
  accessDescription: {
    id: 'oauthAuthorize.authorizeForm.accessDescription',
    defaultMessage:
      'By granting {clientName} access to your Starbucks account, this application will be able to:',
    description:
      'Description of authorizing types of information to grant access.',
  },
  confirmButton: {
    id: 'oauthAuthorize.authorizeForm.confirmButton',
    defaultMessage: 'Confirm',
    description: 'Text for confirm button on authorization form.',
  },
});
